import GET_ALL_PRODUCTS from "../graphql/allProducts.gql";
import GET_PRODUCTS from "../graphql/allProductsByCardCode.gql";
import { apolloClient } from './apollo'
/**
 * This is only mock api
 */
export function getProducts() {
    return apolloClient.query({
      query: GET_ALL_PRODUCTS,
      fetchPolicy: window.navigator.onLine ? 'network-only' : 'cache-first'
    })
}
export function getProductsByCardCode(cardCode,searchField,userText,pageSize,currentPage,countPage,currency) {
    return apolloClient.mutate({
        mutation: GET_PRODUCTS,
        variables: {
            searchField: (searchField) ? searchField : "",
            cardCode: (cardCode) ? cardCode : "",
            userText: (userText) ? userText : "",
            pageSize: (pageSize) ? pageSize : "",
            currentPage: (currentPage) ? currentPage : "1",
            countPage: (countPage) ? countPage : "",
            currency: (currency) ? currency : ""
        }
    })
}
